// extracted by mini-css-extract-plugin
export var active = "Tabs-module--active--NIa-s";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var tab = "Tabs-module--tab--vuZ-d";
export var tabs = "Tabs-module--tabs--XS2HH";